// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const entitiesExportFields = [
  {
    titleIntlKey: "entities.columns.additionalNames.title",
    fields: [
      "additionalNamesNamePlaceLatin",
      "additionalNamesNamePlaceLocal",
      "additionalNamesNameShortLatin",
      "additionalNamesNameShortLocal",
    ],
  },
  {
    titleIntlKey: "entities.columns.address.title",
    fields: [
      "addressAddress1",
      "addressAddress2",
      "addressAddress3",
      "addressCity",
      "addressCountryCode",
      "addressLatitude",
      "addressLongitude",
      "addressPostalCode",
      "addressState",
    ],
  },
  {
    titleIntlKey: "entities.columns.entity.title",
    fields: [
      "entityId",
      "forceEntityId",
      "externalId",
      "alternateVenueIds",
      "ageGroup",
      "codeLatin",
      "codeLocal",
      "discipline",
      "gender",
      "grade",
      "internationalReference",
      "nameFullLatin",
      "nameFullLocal",
      "representing",
      "standard",
      "status",
    ],
  },
  {
    titleIntlKey: "entities.columns.colors.title",
    fields: ["colorsPrimary", "colorsSecondary", "colorsTertiary"],
  },
  {
    titleIntlKey: "entities.columns.contacts.title",
    fields: ["contactsEmail", "contactsFax", "contactsPhone", "contactsPhoneSecondary"],
  },
  {
    titleIntlKey: "entities.columns.details.title",
    fields: ["detailsFounded", "detailsSquadValue"],
  },
  {
    titleIntlKey: "entities.columns.defaultVenue.title",
    fields: ["defaultVenueId", "defaultVenueExternalId", "defaultVenueName"],
  },
  {
    titleIntlKey: "entities.columns.entityGroup.title",
    fields: ["entityGroupId", "entityGroupExternalId", "entityGroupName"],
  },
  {
    titleIntlKey: "entities.columns.social.title",
    fields: ["socialFacebook", "socialInstagram", "socialTicketing", "socialTiktok", "socialTwitter", "socialWebsite", "socialWikipedia"],
  },
];

export const defaultEntitiesExportFieldNames = [
  "entityId",
  "ageGroup",
  "codeLocal",
  "discipline",
  "gender",
  "nameFullLocal",
  "representing",
  "standard",
  "status",
];
